import React from "react";
import { useHistory } from "react-router-dom";
import getString from "../../../../config/strings";
import { isMobile } from "../../../../utils/common";
import Button from "../../../common/Button";
import { featuresConfig } from "./config";
import {
  FeaturesContainer,
  FeatureSelector,
  FeatureOption,
  FeatureSection,
  FeatureTextSection,
  FeatureHeading,
  FeatureText,
  FeatureImageContainer,
  FeatureImage,
  DashboardButtonContainer,
} from "./styles";
import ReactGA from "react-ga";

function Features() {
  const [selectedFeature, setSelectedFeature] = React.useState(0);
  let history = useHistory();
  return (
    <FeaturesContainer>
      {!isMobile() && (
        <FeatureSelector>
          {Object.keys(featuresConfig).map((feature, index) => {
            return (
              <FeatureOption
                active={index === selectedFeature}
                onClick={() => {
                  ReactGA.event({
                    category: 'Home',
                    action: 'Selected Feature',
                    label:feature,
                  });
                  setSelectedFeature(index);
                }}
              >
                {feature}
              </FeatureOption>
            );
          })}
        </FeatureSelector>
      )}
      {Object.keys(featuresConfig).map((feature, index) => {
        if (index % 2 === 0 || isMobile()) {
          return (
            <FeatureSection onDisplay={index === selectedFeature}>
              <FeatureTextSection padddingSide="right">
                <FeatureHeading>
                  {featuresConfig[feature].heading}
                </FeatureHeading>
                <FeatureText>{featuresConfig[feature].text}</FeatureText>
                <DashboardButtonContainer>
                  <Button
                    text={getString("View") + " " + feature}
                    onClick={() => {
                      ReactGA.pageview('/app/browser');
                      history.push("/app/browser");
                    }}
                  />
                </DashboardButtonContainer>
              </FeatureTextSection>
              <FeatureImageContainer>
                <FeatureImage src={featuresConfig[feature].image} />
              </FeatureImageContainer>
            </FeatureSection>
          );
        } else {
          return (
            <FeatureSection onDisplay={index === selectedFeature}>
              <FeatureImageContainer>
                <FeatureImage src={featuresConfig[feature].image} />
              </FeatureImageContainer>
              <FeatureTextSection padddingSide="left">
                <FeatureHeading>
                  {featuresConfig[feature].heading}
                </FeatureHeading>
                <FeatureText>{featuresConfig[feature].text}</FeatureText>
                <DashboardButtonContainer>
                  <Button
                    text={getString("View") + " " + feature}
                    onClick={() => {
                      history.push("/app/browser");
                    }}
                  />
                </DashboardButtonContainer>
              </FeatureTextSection>
            </FeatureSection>
          );
        }
      })}
    </FeaturesContainer>
  );
}
export default Features;
